import './featured-projects.css';
import { Link } from 'react-router-dom';
import { ArrowCircleRight } from '../shared/icons';
import Button from '../shared/button';


export default ({projects, type}) => {

  return <article className={`featured-projects ${type === 'card' ? 'featured-projects-card': ''}`}>
    <h2>Our Projects</h2>
      <p>Current NRNA Australia Committees and Task Forces</p>
      <ul className="project-list">
        {projects.map(committee => {
          return <li className="project-list-item" key={committee.title}>{committee.title}</li>;
        })}
      </ul>
      <Link to="/projects"><Button icon={ArrowCircleRight} type="text">View All Projects</Button></Link>
  </article>
}